//UserMenu filter types.................

export interface SearchBarProps {
  fields: Field[];
  onSubmit: () => void;
  buttonLabel?: string;
}

export type Field = InputField | SelectField;

export interface SelectField {
  type: "select";
  options: { value: string; label: string }[];
  title?: string; // Add the title field here
}
export enum SocialMediaTypeEnum {
  GOOGLE = "GOOGLE",
  FACEBOOK = "FACEBOOK",
} 
export interface OAuthLoginRequestBody {
  accessToken: string;
  loginOauthType: SocialMediaTypeEnum;
  loginRequestType: "OAUTH_FACTOR_SIGN_IN";
  code: string;
}

export interface OAuthLoginResponse {
  twoFactorStatus: boolean;
  accessToken: string;
  refreshToken: string;
  emailId: string;
}
interface InputField {
  type: "date" | "text" | "number";
  placeholder?: string;
  title?: string; // Add this line to include the title field
}

export interface HeaderProps {
  title: string;
  ProfitLoss?: number;
  customBgColor?: string;
  balance?: number; 
  exposure?: number;
}

//UserMenu filter types..................

//UserMenu tableData types...................

export interface AccountStatementDataType {
  DATE: string;
  TRANSACTION: string;
  "EVENT NAME": string;
  "MARKET TYPE": string;
  "CREDIT/DEBIT": number;
  "CLOSING BALANCE": number;
  "TRANSACTION ID": string;
}

export interface BettingProfitLossDataType {
  MARKET: string;
  "START TIME": string;
  "SETTLED TIME": string;
  COMMUNICATION: string;
  "NET WIN": number;
}

export interface MyBetDataType {
  PLACEDATE: string;
  EVENTNAME: string;
  MARKET: string;
  BETON: string;
  BETTYPE: string;
  ODDS: number;
  AMOUNT: number;
  RESULT: string;
  WINNINGS: number;
}

export interface MyWalletDataType {
  DATE: string;
  TRANSACTION: string;
  "CREDIT/DEBIT": number;
  BALANCE: number;
  DESCRIPTION: string;
}

export interface BonusStatementDataType {
  "BONUS TYPE": string;
  "APPROVAL REQ": boolean;
  "AWARDED DATE": string;
  "AWARDED AMT.": number;
  TURNOVER: number;
  INSTALLMENTS: number;
  "REDEEMED AMT": number;
  STATUS: string;
  "LAST DATE": string;
}

export interface MyTransactionsDataType {
  "TRANSACTION TIME": string;
  "TRANSACTION ID": string;
  "TRANSACTION TYPE": string;
  AMOUNT: number;
  "APPROVED AMT": number;
  STATUS: string;
  NOTES: string;
  "PAYMENT METHOD": string;
}

export interface TurnoverHistory {
  "EVENT DATE": string; // Use string if you want to keep the exact structure
  "TRANSACTION TYPE": string;
  "EVENT NAME": string;
  MARKET: string;
  "MARKET TYPE": string;
  AMOUNT: number;
  "TURNOVER BALANCE": number;
}

//UserMenu tableData types...................

export enum MyProfileTabEnum {
  PERSONAL = "Personal",
  CHANGE_PASSWORD = "Change Password",
  TWO_FACTOR_AUTH = "Two Factor Auth",
  REFERRAL = "Referral",
}

export interface IUserMenuTabs {
  tabName: string;
  content: JSX.Element;
}

export enum AffiliateProgramTabEnum {
  CAMPAIGN = "Campaign",
  COMMISSION = "Commission",
  FUNDS = "Funds",
}
